import Constants from '../constants/constants';
var regex = Constants.Regex;
import moment from 'moment-timezone';

/**
 * checks if a formb is valid for the given user type (dispatcher or field user)
 * @param _forma
 * @param userType
 * @returns {*}
 */
function checkFormValidity(_forma, userType) {

    var _isDirty = false;//assume false unless we find a change
    var errors = [];
    var warnings = [];
    var dateRegex = new RegExp(regex.dateRegex);
    var timeRegex = new RegExp(regex.timeRegex);
    var phoneRegex = new RegExp(regex.phoneRegex);
    var speedRegex = new RegExp(regex.speedRegex);
    var speedNARegex = new RegExp(regex.speedNARegex);

    var effectiveDateEntered = true;
    var effectiveTimeEntered = true;
    var estimatedRemovalDateTimePresent = true;
    if (!_forma.effectiveDate || _forma.effectiveDate.length === 0) {
        //estimatedRemovalDateTimePresent = false;
        effectiveDateEntered = false;
    }
    else if (!dateRegex.test(_forma.effectiveDate)) {
        _isDirty = true;
        estimatedRemovalDateTimePresent = false;
        errors.push({ field: 'effectiveDate', message: 'Effective Date: must in format MMddYY', type: 'error' })
    }
    else
        _isDirty = true;

    var validMileage = true;

    if (_forma.trackGuids.length > 0) {
        var foundStartMp = false; //There is a requirement that any guids selected must be within .1 of a mile of the start and end mp to be a valid restriction
        var foundEndMp = false;
        _forma.trackGuids.forEach(function (elem) {
            var bmp = elem.beginMp;
            var emp = elem.endMp;

            if (Math.abs(bmp - _forma.workStartMp) < .1 || Math.abs(emp - _forma.workStartMp) < .1) {
                foundStartMp = true;
            }

            if (Math.abs(bmp - _forma.workEndMp) < .1 || Math.abs(emp - _forma.workEndMp) < .1) {
                foundEndMp = true;
            }
        });

        validMileage = foundStartMp && foundEndMp;
    } else {
        errors.push({ field: 'tracks', message: Constants.ValidationConstants.NO_TRACK_FOUND, type: 'error' });
    }

    if (!validMileage) {
        errors.push({ field: 'tracks', message: Constants.ValidationConstants.UNDERPROTECT_ERROR_MESSAGE, type: 'error' });
    }


    if (!_forma.effectiveTime || _forma.effectiveTime.length === 0) {
        //estimatedRemovalDateTimePresent = false;
        effectiveTimeEntered = false;
    }
    else if (!timeRegex.test(_forma.effectiveTime)) {
        _isDirty = true;
        estimatedRemovalDateTimePresent = false;
        errors.push({ field: 'effectiveTime', message: 'Effective Time: must in format HHmm', type: 'error' })
    }
    else
        _isDirty = true;

    if (effectiveDateEntered != effectiveTimeEntered) {
        if (!effectiveDateEntered) {
            errors.push({
                field: 'effectiveDate',
                message: 'Effective Date is required if Effective Time entered',
                type: 'error'
            })
            //estimatedRemovalDateTimePresent = false;
        }
        else if (!effectiveTimeEntered) {
            errors.push({
                field: 'effectiveTime',
                message: 'Effective Time is required if Effective Date entered',
                type: 'error'
            })
            //estimatedRemovalDateTimePresent = false;
        }
    }

    var effectiveDatePreviousEntered = true;
    var effectiveTimePreviousEntered = true;

    if (!_forma.effectiveDatePrevious || _forma.effectiveDatePrevious.length === 0) {
        //estimatedRemovalDateTimePresent = false;
        effectiveDatePreviousEntered = false;
    }

    if (!_forma.effectiveTimePrevious || _forma.effectiveTimePrevious.length === 0) {
        //estimatedRemovalDateTimePresent = false;
        effectiveTimePreviousEntered = false;
    }

    if (userType.indexOf(Constants.Roles.FIELD_USER) < 0) {//if not a field user
        if (effectiveDatePreviousEntered) {
            if (!effectiveDateEntered) {
                errors.push({
                    field: 'effectiveDate',
                    message: 'Effective Date can be modified, but should not be removed',
                    type: 'error'
                })
            }
        }

        if (effectiveTimePreviousEntered) {
            if (!effectiveTimeEntered) {
                errors.push({
                    field: 'effectiveTime',
                    message: 'Effective Time can be modified, but should not be removed',
                    type: 'error'
                })
            }
        }
    }

    if (!_forma.expectedExpireDate || _forma.expectedExpireDate.length === 0) {
        errors.push({
            field: 'expectedExpireDate',
            message: 'Estimated Removal: Please fill out this field',
            type: 'error'
        })
        estimatedRemovalDateTimePresent = false;
    }
    else if (!dateRegex.test(_forma.expectedExpireDate)) {
        _isDirty = true;
        estimatedRemovalDateTimePresent = false;
        errors.push({ field: 'expectedExpireDate', message: 'Estimated Removal: must in format MMddYY', type: 'error' })
    }

    else
        _isDirty = true;


    if (estimatedRemovalDateTimePresent) {
        _isDirty = true;
        //verify timespans
        var dateValidity = areDateTimeTimespanValid(_forma, userType); //return null if valid, otherwise errors
        //if (!dateValidity.isValid){
        dateValidity.errors.forEach(function (error, i) {
            errors.push(error);
        });

        dateValidity.warnings.forEach(function (warn, i) {
            warnings.push(warn);
        });

        //}
    }

    if (speedNARegex.test(_forma.passengerSpeed) && speedNARegex.test(_forma.freightSpeed)) {
        errors.push({
            field: 'passengerFreightSpeed',
            message: 'Passenger or Freight Speed is required (NA for no value)',
            type: 'error'
        })
    }
    else
        _isDirty = true;

    if (!speedRegex.test(_forma.passengerSpeed)) {
        errors.push({ field: 'passengerSpeed', message: 'Passenger Speed: must be greater than 0 or NA', type: 'error' })
    }
    else
        _isDirty = true;

    if (!speedRegex.test(_forma.freightSpeed)) {
        errors.push({ field: 'freightSpeed', message: 'Freight Speed: must be greater than 0 or NA', type: 'error' })
    }
    else
        _isDirty = true;

    if (!_forma.phoneNumber || _forma.phoneNumber.length === 0) {
        if (userType.indexOf(Constants.Roles.FIELD_SLODT) > -1 && _forma.status == Constants.RestrictionStatuses.ISSUED) {
            //this user has slodt permissions and is modifying a restriction (SLODT action), so make this field optional
            //ie no op
        }
        else if (userType.indexOf(Constants.Roles.FIELD_USER) > -1) {
            //if this is a field user, the phone number is required
            errors.push({ field: 'phoneNumber', message: 'Phone Number: Please fill out this field', type: 'error' })
        }
    } else if (!phoneRegex.test(_forma.phoneNumber)) {//regardless of required or not, validate it if present
        _isDirty = true;
        errors.push({ field: 'phoneNumber', message: 'Phone Number: must be in format xxx-xxx-xxxx', type: 'error' })
    }


    if (!_forma.authorizedBy || _forma.authorizedBy.length === 0) {
        errors.push({
            field: 'authorizedBy', message: 'Requested By: Please fill out this field', type: '' +
                '.error'
        })
    }
    else
        _isDirty = true;

    //		if(userType.indexOf(Constants.Roles.DISPATCHER) > -1) {
    //			if(!_forma.sloDtComment || _forma.sloDtComment.length === 0) {
    //				errors.push({field: 'sloDtComment', message: 'Slow order change comment:  Please fill out this field', type: 'error'})
    //			}
    //			else {
    //				_isDirty = true
    //			}
    //		}


    return { isValid: errors.length === 0, errors: errors, isDirty: _isDirty, warnings: warnings }
}

/**
 * checks whether the timespan on the formb is valid for the user type
 * assumes that all the times and dates are present
 * @param _forma
 * @param userType
 * @returns {{isValid: boolean, warnings: Array, errors: Array}}
 */
function areDateTimeTimespanValid(_forma, userType) {

    //do not call this method if any date or time input is not in a correct format (ie not blank, 4 digits, etc)
    var errors = [];
    var warnings = [];

    var formATimeZone = '';

    if (_forma.timezone != null) {
        formATimeZone = _forma.timezone;
    }

    var effectiveTime = moment.tz(_forma.effectiveDate + _forma.effectiveTime, 'MMDDYYHHmm', Constants.Timezones[formATimeZone]);
    var estimatedRemoval = moment.tz(_forma.expectedExpireDate, 'MMDDYY', Constants.Timezones[formATimeZone]);

    var now = moment().tz(Constants.Timezones[formATimeZone]);
    var tomorrow = moment().tz(Constants.Timezones[formATimeZone]).add(1, 'days');
    var threeDaysFromNow = moment().tz(Constants.Timezones[formATimeZone]).add(3, 'days');

    if (!estimatedRemoval.isValid()) {
        errors.push({
            message: 'Estimated Removal Date is not a valid date time',
            field: 'expectedExpireDate',
            type: 'error'
        })
    }
    else {
        //Set the endDateTime to 23:59 to allow start and end to be on the same day
        estimatedRemoval.add(23, 'hours').add(59, 'minutes');
    }

    //this also effectively checks it against the effective data/time if it wasn't entered...
    if (estimatedRemoval.isBefore(tomorrow)) {
        errors.push({
            field: 'expectedExpireDate',
            message: 'Estimated Removal Date must be in the future',
            type: 'error'
        })
    }

    if (!effectiveTime.isValid()) {
        //don't check this
        return { isValid: errors.length === 0, warnings: warnings, errors: errors };
    }
    else {
        //start date must be after now
        if (userType.indexOf(Constants.Roles.FIELD_SLODT) > -1 && _forma.status === Constants.RestrictionStatuses.ISSUED) {
            //this user has slodt permissions and is modifying a restriction (SLODT action), so effective time can be in the past
            //ie no op
        } else if (!now.isBefore(effectiveTime)) {
            errors.push({ field: 'effectiveTime', message: 'Effective Date: must be in the future', type: 'error' })
        }

        if (effectiveTime.isAfter(threeDaysFromNow)) {
            errors.push({
                field: 'effectiveTime',
                message: 'Effective Date must be less than 72 hours in the future',
                type: 'error'
            })
        }

        if (effectiveTime.isAfter(estimatedRemoval)) {
            errors.push({
                field: 'effectiveTime',
                message: 'Estimated Removal Date must be after Effective Date time',
                type: 'error'
            })
        }

        //if (effectiveTime.diff(estimatedRemoval) === 0){
        //	errors.push({field: 'effectiveTime', message: 'Effective Date and Estimated Removal Date must be different', type: 'error'})
        //}
    }

    return { isValid: errors.length === 0, warnings: warnings, errors: errors };
}


//public api
export const formAValidation = {
    checkFormValidity: checkFormValidity,
    checkDateTimeValidity: areDateTimeTimespanValid
};
